import axios from 'axios';
import { API_BASE_URL } from './config';
import { createBackendReadiness } from './utils/backendWakeup';

export { API_BASE_URL };

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 35000,
});

const ensureBackendReady = createBackendReadiness(() =>
  axios.get(`${API_BASE_URL}/health`, { timeout: 60000 })
);

function isHealthRequest(config) {
  const url = String(config.url || '').split('?')[0].replace(/\/+$/, '');
  return url === '/health' || url.endsWith('/health');
}

api.interceptors.request.use(config => {
  const token = localStorage.getItem('admin_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.request.use(async config => {
  if (!config.skipBackendWarmup && !isHealthRequest(config)) {
    await ensureBackendReady().catch(() => undefined);
  }
  return config;
});

api.interceptors.response.use(
  r => r,
  err => {
    if (err.response?.status === 428 && err.response?.data?.mustChangePassword) {
      localStorage.removeItem('admin_token');
      window.location.href = '/login';
    }
    if (err.response?.status === 401 || err.response?.status === 403) {
      localStorage.removeItem('admin_token');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;
